import {
  axiosConfig,
  del,
  get,
  patch,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  Resident,
  ResidentPayload,
  ResidentRecord,
  ResidentStats,
} from "@project/types/resident";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/residents`;
const SILENT: RequestConfig = { showNotification: false };

class ResidentService {
  listResidentsPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<ResidentRecord, ResidentStats>> => {
    return fetchListPage<ResidentRecord, ResidentStats>(`${BASE}/`, query);
  };

  getResident = async (id: number): Promise<ResidentRecord | undefined> => {
    const data = await get<ApiItemResponse<ResidentRecord> | ResidentRecord>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  create = async (payload: ResidentPayload): Promise<Resident> => {
    const response = await axiosConfig.post<
      ApiItemResponse<Resident> | Resident
    >(`${BASE}/`, payload, SILENT);
    const item = unwrapItem(response.data);
    if (!item) {
      throw new Error("Failed to save resident.");
    }
    return item;
  };

  update = async (
    id: number,
    payload: Partial<ResidentPayload>
  ): Promise<ResidentRecord | undefined> => {
    const data = await patch<
      ApiItemResponse<ResidentRecord> | ResidentRecord,
      Partial<ResidentPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const residentService = new ResidentService();
